/// <amd-module name="Comments/Viewer/CommentViewerToolbar" />
export { CommentViewerToolbar } from "Comments/Viewer/Components/CommentViewerToolbar";
export { ICommentViewerToolbarProps } from "Comments/Viewer/Components/CommentViewerToolbar.Props";
